<template>

  <Cascader
      v-model="value"
      :options="options"
      :props="propsConfig"
      :size="size"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="clearable"
      :collapse-tags="collapseTags"
      :popper-class=className
      @change="change"
  >
    <template slot-scope="{ node, data }">
      <span :class="[node.isLeaf?'leaf':'unleaf']">{{ data[propsConfig.label] }}  </span>
    </template>
  </Cascader>


</template>

<script>
import { Cascader } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

export default {
  name: 'el-cascader-onlylast-mutiple',
  computed: {
    className() {
      return `el-cascader-onlylast-mutiple ${this.popperClass}`;
    }
  },
  props: {
    visibleData: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => {

      }
    },
    size: {
      type: String,
      default: 'medium'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    popperClass: {
      type: String,
      default: 'test'
    }

  },
  data() {
    return {
      value: [],
      propsConfig: {
        multiple: true,
        label: 'label',
        value: 'value',
        expandTrigger: 'click',
        children:"children",
        disabled:'disabled'
      }
    };
  },
  components: {
    Cascader
  },
  created() {
    this.value = JSON.parse(JSON.stringify(this.visibleData));
     Object.assign(this.propsConfig,this.props);
  },

  methods: {
    change() {
      this.$emit('change', this.value);
    }
  }
};
</script>

<style>
.el-cascader-onlylast-mutiple .el-cascader-node:has(.unleaf) .el-checkbox {
  display: none;
}
</style>
